import IdentityService from "../services/IdentityService";
import { formatISO } from "date-fns";

import ConfigService from "../services/ConfigService";

IdentityService

/*
        public string Id {get; set;} // Sequential Guid
        public string ErrorSystem {get; set;}
        public string? ErrorSystemVersion {get; set;}
        public string ErrorSource {get; set;}
        public string? Gcid {get; set;}
        public string ErrorDate {get; set;} // Iso8601 w Timezone
        public string? LoggedBy {get; set;}
        public string? Requestor {get; set;}
        public string? Comments {get; set;}
        public string? ErrorCode {get; set;}
        public string? ErrorDescription {get; set;}
        public string? ErrorSeverity {get; set;}
        public string? StackTrace {get; set;}
*/



export default class ErrorEvent 
{
    constructor(gcid, errorDate, errorSource, loggedBy, requestor, comments, errorCode, errorDescription, errorSeverity, stackTrace, id, errorSystem, errorSystemVersion)
    {


        this.id = id || IdentityService.makeUuid();
        this.errorSystem = errorSystem || "obs";
        this.errorSystemVersion = errorSystemVersion || new ConfigService().getAppVersion();
        this.errorSource = errorSource || "";
        this.gcid = gcid || "";
        this.errorDate = errorDate || formatISO(new Date());
        this.loggedBy = loggedBy || "";
        this.requestor = requestor || "";
        this.comments = comments || "";
        this.errorCode = errorCode || "";
        this.errorDescription = errorDescription || "";
        this.errorSeverity = errorSeverity || "";
        this.stackTrace = stackTrace || "";
    }


}